export default "__VITE_ASSET__949e1d4d__"